<ng-container *ngIf="vm$ | async as vm">
	<aside class="world-shell-nav">
		<div class="world-sidebar" [class.is-collapsed]="collapsed">
			<div class="world-sidebar__header">
				<button type="button" class="world-sidebar__toggle" [attr.aria-expanded]="!collapsed"
					[attr.aria-controls]="navId" (click)="toggleSidebar()">
					{{ collapsed ? 'Expand' : 'Collapse' }}
				</button>
				<p class="kicker world-sidebar__kicker">World Navigation</p>
			</div>
	
			<div class="world-sidebar__nav" [id]="navId">
				<nav class="world-nav" [class.is-collapsed]="collapsed">
					<div *ngFor="let group of navGroups; index as groupIndex" class="world-nav-group"
						[class.is-expanded]="!isGroupCollapsed(group.label)"
						[style.--nav-accent]="accentFor(group.category)">
						<button type="button" class="world-nav-group__header"
							[attr.aria-expanded]="!isGroupCollapsed(group.label)" (click)="toggleGroup(group.label)"
							[title]="group.id === 'world' && vm.worldName ? vm.worldName : group.label">
							<span class="world-nav-group__title">
								<span class="world-nav-group__label">
									{{ group.id === 'world' && vm.worldName ? vm.worldName : group.label }}
								</span>
								<span class="world-nav-group__count">
									({{ groupCount(vm.counts, group.countKeys) }})
								</span>
							</span>
							<span class="world-nav-group__chevron" aria-hidden="true">
								<span *ngIf="isGroupCollapsed(group.label)">></span>
								<span *ngIf="!isGroupCollapsed(group.label)">v</span>
							</span>
						</button>
	
						<ul *ngIf="collapsed || !isGroupCollapsed(group.label)">
							<li *ngFor="let link of group.links; index as linkIndex">
								<a [routerLink]="linkTarget(link.slug)" routerLinkActive="active"
									[routerLinkActiveOptions]="{ exact: link.slug === '' }"
									[style.--nav-accent]="accentFor(group.category, linkIndex)">
									<span class="world-nav-link__icon" aria-hidden="true">
										<ng-container [ngSwitch]="link.icon">
											<svg *ngSwitchCase="'home'" viewBox="0 0 24 24" width="18" height="18"
												fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"
												stroke-linejoin="round">
												<path d="M4 11.5 12 4l8 7.5" />
												<path d="M6.5 10.5v8h4v-5h3v5h4v-8" />
											</svg>
											<svg *ngSwitchCase="'globe'" viewBox="0 0 24 24" width="18" height="18"
												fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"
												stroke-linejoin="round">
												<circle cx="12" cy="12" r="9" />
												<path d="M3 12h18M12 3a15 15 0 0 0 0 18M12 3a15 15 0 0 1 0 18" />
											</svg>
											<svg *ngSwitchCase="'map'" viewBox="0 0 24 24" width="18" height="18"
												fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"
												stroke-linejoin="round">
												<path d="M9 5 3 8v11l6-3 6 3 6-3V5l-6 3-6-3Z" />
												<path d="M9 5v11m6-8v11" />
											</svg>
											<svg *ngSwitchCase="'person'" viewBox="0 0 24 24" width="18" height="18"
												fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"
												stroke-linejoin="round">
												<circle cx="12" cy="8" r="3.2" />
												<path d="M6 20c1.6-2.6 4-3.9 6-3.9s4.4 1.3 6 3.9" />
											</svg>
											<svg *ngSwitchCase="'group'" viewBox="0 0 24 24" width="18" height="18"
												fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"
												stroke-linejoin="round">
												<circle cx="8" cy="9" r="3" />
												<circle cx="16" cy="9" r="3" />
												<path d="M4 19c0-2.2 2-4 4-4s4 1.8 4 4" />
												<path d="M12 19c0-2.2 2-4 4-4s4 1.8 4 4" />
											</svg>
											<svg *ngSwitchCase="'shield'" viewBox="0 0 24 24" width="18" height="18"
												fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"
												stroke-linejoin="round">
												<path d="M12 3 5 6v5.8c0 3.4 2.8 6.5 7 9.2 4.2-2.7 7-5.8 7-9.2V6Z" />
											</svg>
											<svg *ngSwitchCase="'shop'" viewBox="0 0 24 24" width="18" height="18"
												fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"
												stroke-linejoin="round">
												<path d="M4 11h16v8H4Z" />
												<path d="M5 7h14l-1 4H6Z" />
												<path d="M9 11v8m6-8v8" />
											</svg>
											<svg *ngSwitchCase="'box'" viewBox="0 0 24 24" width="18" height="18"
												fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"
												stroke-linejoin="round">
												<path d="M4 7 12 3l8 4v10l-8 4-8-4Z" />
												<path d="M4 7l8 4 8-4M12 11v10" />
											</svg>
											<svg *ngSwitchCase="'bag'" viewBox="0 0 24 24" width="18" height="18"
												fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"
												stroke-linejoin="round">
												<path d="M7 9h10l-1 11H8Z" />
												<path d="M9 9a3 3 0 1 1 6 0" />
											</svg>
											<svg *ngSwitchCase="'book'" viewBox="0 0 24 24" width="18" height="18"
												fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"
												stroke-linejoin="round">
												<path d="M5 5h8a3 3 0 0 1 3 3v11H5Z" />
												<path d="M5 16h11" />
											</svg>
											<svg *ngSwitchCase="'flag'" viewBox="0 0 24 24" width="18" height="18"
												fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"
												stroke-linejoin="round">
												<path d="M5 5v15" />
												<path d="M5 5h10l-2 4 2 4H5" />
											</svg>
											<svg *ngSwitchCase="'spark'" viewBox="0 0 24 24" width="18" height="18"
												fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"
												stroke-linejoin="round">
												<path
													d="M12 4v4M12 16v4M6 8l3.5 2M14.5 14 18 16M6 16l3.5-2M14.5 10 18 8M4 12h4m8 0h4" />
												<circle cx="12" cy="12" r="2" />
											</svg>
											<svg *ngSwitchCase="'atom'" viewBox="0 0 24 24" width="18" height="18"
												fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"
												stroke-linejoin="round">
												<circle cx="12" cy="12" r="1.6" />
												<ellipse cx="12" cy="12" rx="9" ry="4.5" transform="rotate(30 12 12)" />
												<ellipse cx="12" cy="12" rx="9" ry="4.5" transform="rotate(-30 12 12)" />
												<ellipse cx="12" cy="12" rx="9" ry="4.5" />
											</svg>
											<svg *ngSwitchCase="'media'" viewBox="0 0 24 24" width="18" height="18"
												fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"
												stroke-linejoin="round">
												<rect x="4" y="6" width="16" height="12" rx="2" />
												<path d="m9 11 2.5 2.5L14 12l3 3" />
												<circle cx="8" cy="10" r="1" />
											</svg>
											<svg *ngSwitchCase="'target'" viewBox="0 0 24 24" width="18" height="18"
												fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"
												stroke-linejoin="round">
												<circle cx="12" cy="12" r="7" />
												<circle cx="12" cy="12" r="3" />
												<path d="M12 5V3m0 18v-2M5 12H3m18 0h-2" />
											</svg>
											<svg *ngSwitchDefault viewBox="0 0 24 24" width="18" height="18" fill="none"
												stroke="currentColor" stroke-width="1.6" stroke-linecap="round"
												stroke-linejoin="round">
												<circle cx="12" cy="12" r="6" />
											</svg>
										</ng-container>
									</span>
									<span class="world-nav-link__text">
										<span class="world-nav-link__label">{{ link.label }}</span>
										<span *ngIf="link.countKey" class="world-nav-link__count">
											({{ linkCount(vm.counts, link.countKey) }})
										</span>
									</span>
								</a>
							</li>
						</ul>
					</div>
				</nav>
			</div>
		</div>
	</aside>
</ng-container>
